import {CustomNodeInfoPopup} from "./CustomNodeInfoPopup";
import React from "react";

export const CustomNodeTitle = (props) => {
    const {node} = props;
    const {markAsUnused} = props;
    return (
        <div className={"srd-default-node__title " + (markAsUnused ? ' unused' : '')}>
            <div className={"srd-default-node__name"} style={{verticalAlign: 'center'}}>
                <span>{node.name}</span>
                <CustomNodeInfoPopup id={node.getID()}/>
            </div>
        </div>
    )
}